import { createAction } from "typesafe-actions";
import { prefix } from "./constants.js";
const resetArchiveUnarchiveResult = createAction(`${prefix}/RESET`);
export {
  resetArchiveUnarchiveResult
};
//# sourceMappingURL=actions.js.map
